var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "esignHandle" },
    [
      _c(
        "div",
        [
          (_vm.signImg ? true : false)
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.signNameClick },
                },
                [_vm._v("选择已有签名")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.newSignNameClick },
            },
            [_vm._v("使用新的签名")]
          ),
        ],
        1
      ),
      _vm.isShowSignImg
        ? _c("div", [
            _c("img", {
              staticStyle: {
                width: "260px",
                height: "66px",
                "object-fit": "contain",
              },
              attrs: { src: _vm.currentSelectSignImg },
            }),
          ])
        : _vm._e(),
      _c("esignCode", { ref: "esign", on: { getImgUrl: _vm.esignHandle } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }